import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";


export const useAcoesMelhoriasPagination = create<PaginationProperties & SetPaginationProperties>((set) => ({
    ...InitializePaginationProperties(),
    ...InitializeSetPaginationProperties(set),
}));